<div class="adaptive-grow-1">
    <div class="fluent-container">
        <br />
        <div class="title-color">
            <h1>EXPORTAR SUCESOS</h1>
        </div>
        <div class="form-body">
            <form [formGroup]="exportForm" (ngSubmit)="exportIncident()">
                <div
                    cdkDropList
                    cdkDropListOrientation="mixed"
                    class="chips-container"
                    (cdkDropListDropped)="drop($event)"
                >
                    @for (field of fields(); track field.key) {
                        <div class="chip-item" cdkDrag>
                            {{ field.label }}
                            <button class="remove-btn" (click)="remove(field)">
                                ✕
                            </button>
                        </div>
                    }
                </div>
                <br />
                <div class="line">
                    <div class="column-md-6 column-lg-6 column-sm-6">
                        <mat-form-field appearance="outline">
                            <mat-label>Desde:</mat-label>
                            <input
                                matInput
                                [matDatepicker]="registeredAtpicker"
                                placeholder="Desde:"
                                formControlName="date_from"
                            />
                            <mat-datepicker-toggle
                                matSuffix
                                [for]="registeredAtpicker"
                            >
                            </mat-datepicker-toggle>
                            <mat-datepicker
                                #registeredAtpicker
                            ></mat-datepicker>
                            <mat-error
                                class="for-text text-danger"
                                *ngIf="
                                    exportForm
                                        .get('date_from')
                                        ?.hasError('required')
                                "
                            >
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="column-md-6 column-lg-6 column-sm-6">
                        <mat-form-field appearance="outline">
                            <mat-label>Hasta:</mat-label>
                            <input
                                matInput
                                [matDatepicker]="pickerTo"
                                placeholder="Hasta:"
                                formControlName="date_to"
                            />
                            <mat-datepicker-toggle
                                matSuffix
                                [for]="pickerTo"
                            ></mat-datepicker-toggle>
                            <mat-datepicker #pickerTo></mat-datepicker>
                            <mat-error
                                class="for-text text-danger"
                                *ngIf="
                                    exportForm
                                        .get('date_to')
                                        ?.hasError('required')
                                "
                            >
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <br />
                <button type="submit" class="primary-button" id="guardar">
                    <span class="button-content"
                        ><mat-icon>system_update_alt</mat-icon>Exportar</span
                    >
                </button>
                <button
                    type="button"
                    (click)="closeDialog()"
                    class="secondary-button"
                    id="cancelar"
                >
                    <span class="button-content"
                        ><mat-icon>close</mat-icon>Cancelar</span
                    >
                </button>
            </form>
        </div>
    </div>
</div>
